import { rgba } from 'polished';
import styled from 'styled-components';

import Grid from '@components/basics/grid';

export const TooltipWrapper = styled(Grid)`
  padding: 20px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.differentBackground};
  box-shadow: 0px 0px 20px ${({ theme }) => rgba(theme.colors.black, 0.25)};
  outline: none !important;
  min-width: 160px;
`;
